import React, {useRef} from "react";

const AUTO_INPUT_MS = 300

/**
 * 자동 입력 후 Enter 키가 눌렸을 때 시스템적 입력인지 확인하고,
 * 의도치 않은 콜백 실행을 방지하는 이벤트 핸들러를 반환하는 커스텀 훅.
 *
 * AUTO_INPUT_MS(300ms) 미만의 빠른 Enter 입력시 콜백이 호출되지 않음.
 * 모바일 키패드 인증번호 자동완성을 눌렸을때, 특정브라우저(Safari)에서 의도치 않게 발생중
 *
 * @params callbackFn
 * @return 키보드 이벤트 핸들러
 */
export const useAutoInputGuard = (callbackFn: () => void) => {
    const lastInputTime = useRef(0)

    return (event: React.KeyboardEvent<HTMLInputElement>) => {
        const now = performance.now()

        if (event.key === 'Enter') {
            if (!event.nativeEvent.isTrusted) return // 사용자 입력이 아닌경우 리턴

            const timeSinceLastInput = now - lastInputTime.current
            if (timeSinceLastInput < AUTO_INPUT_MS) return
            callbackFn()
            return
        }

        lastInputTime.current = now
    }
}
